import React from 'react';
import { useSearchParams } from 'react-router-dom';
import YouTubeCuration from './YouTubeCuration';
import VideoLinking from './VideoLinking';
import VideoSuggestions from './VideoSuggestions';
import VideoAnalysis from './VideoAnalysis';
import VideoLinkReports from './VideoLinkReports';

/**
 * YouTube動画の1画面。
 *
 * 選別・店舗紐付け・店名の提案は、**同じ動画を別々の画面で触っていた**。
 * 取り込む動画を選び、どの店で撮られたかを決め、モデルの読みを確定する ──
 * 順番に続く1つの作業で、サイドバーに3つ並べる理由は作った順でしかなかった。
 *
 * タブは ?tab= に入れる。作業の途中でリロードしても同じタブに戻り、
 * 「紐付けのここを見て」とURLを渡せる。
 */
const TABS = [
  { key: 'curation', label: '取り込む動画の選別', render: () => <YouTubeCuration /> },
  { key: 'linking', label: '店舗の紐付け', render: () => <VideoLinking /> },
  { key: 'suggestions', label: '店名の提案（AI）', render: () => <VideoSuggestions /> },
  // 紐付けの次に来る作業。動画を選んで台数を読ませる。
  { key: 'analysis', label: '台数の解析', render: () => <VideoAnalysis /> },
  // 読んだ人が見つけた誤り。**こちらから探しに行けない種類の誤りが来る**
  { key: 'reports', label: 'ユーザーからの報告', render: () => <VideoLinkReports /> },
];

export default function Videos() {
  const [params, setParams] = useSearchParams();
  const requested = params.get('tab');
  const active = TABS.find((t) => t.key === requested) || TABS[0];

  return (
    <div>
      <ul className="nav nav-tabs mb-3">
        {TABS.map((tab) => (
          <li className="nav-item" key={tab.key}>
            <button
              type="button"
              className={`nav-link${tab.key === active.key ? ' active' : ''}`}
              onClick={() => setParams(tab.key === TABS[0].key ? {} : { tab: tab.key })}
            >
              {tab.label}
            </button>
          </li>
        ))}
      </ul>

      {active.render()}
    </div>
  );
}
